const axios = require('axios');

$(document).ready(function() {
    $("#loading").hide();

    window.newsStartAt = 0;

    $("#show-more").on('click', function(e) {
        $("#show-more").fadeOut();
        $("#loading").fadeIn();

        e.preventDefault();

        window.newsStartAt += 10;
        axios.get('/news/getNextTop/' + window.newsStartAt)
            .then(function(resp) {
                $('.home-additional-news-body').append(resp.data);

                $("#show-more").fadeIn();
                $("#loading").fadeOut();
            }).catch(function(e) {
                if (e.response.status === 404) {
                    $("#show-more").hide();
                    $("#loading").fadeOut();
                } else {
                    $("#show-more").fadeIn();
                    $("#loading").fadeOut();
                }
            });

        return false;
    });
});